import { React, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { Col, Row } from 'react-bootstrap'
import { ROUTES } from 'Utils/constants'
import {
  COLOR_STATUS_SALES_ORDER_APPROVE,
  STATUS_SALES_ORDER_APPROVE,
} from './constants'

const SalesOrderApprove = ({ saleOrder, generals }) => {
  const [iconEditOdv, setIconEditOdv] = useState(true)

  const status = () => {
    if (saleOrder.StatusDescription === STATUS_SALES_ORDER_APPROVE.COMPLETE) {
      return COLOR_STATUS_SALES_ORDER_APPROVE.COMPLETE
    } else if (
      saleOrder.StatusDescription === STATUS_SALES_ORDER_APPROVE.IN_PROGRESS
    ) {
      return COLOR_STATUS_SALES_ORDER_APPROVE.IN_PROGRESS
    } else {
      return COLOR_STATUS_SALES_ORDER_APPROVE.DEFAULT
    }
  }
  useEffect(() => {
    if (saleOrder.StatusDescription === STATUS_SALES_ORDER_APPROVE.COMPLETE) {
      setIconEditOdv(false)
    } else {
      setIconEditOdv(true)
    }
  }, [saleOrder?.StatusDescription])

  const documentHeaderID = saleOrder.DocHeaderId || saleOrder.Key
  const documentNumber = saleOrder.DocumentNumber || saleOrder.Description

  const redirectURL = `${ROUTES.saleOrderApprove}${documentHeaderID}/${documentNumber}`

  return (
    <div>
      <Row>
        <div className="quote-activity">
          <Col xl={7} lg={7} md={7} sm={12} xs={12}>
            <div
              className="quote-activity-generals"
              style={{ flexBasis: generals.flex }}>
              <p>
                <span className="strong-text">{saleOrder?.Name}</span>
              </p>
              <p>
                Documento N°:
                {saleOrder?.DocumentNumber || saleOrder?.Description}
              </p>
              <p>
                Fecha de asignación:{' '}
                {saleOrder?.DocumentDate?.slice(0, 10) ||
                  saleOrder?.Date?.slice(0, 10)}
              </p>
            </div>
          </Col>

          <Col xl={2} lg={2} md={2} sm={6} xs={6}>
            <div
              className="quote-activity-status"
              style={{ backgroundColor: status(), borderRadius: 20 }}>
              <p>
                {saleOrder?.DocHeaderStatusDescription ||
                  saleOrder?.StatusDescription}
              </p>
            </div>
          </Col>

          <Col xl={1} lg={1} md={1} sm={6} xs={6}>
            <div className="quote-activity-tooltips">
              {iconEditOdv && (
                <>
                  <div
                    style={{
                      display: 'flex',
                      backgroundColor: '#11D29E',
                      width: '20px',
                      height: '20px',
                      borderRadius: '20%',
                      alignItems: 'center',
                      position: 'relative',
                    }}>
                    <Link to={redirectURL}>
                      <FontAwesomeIcon
                        icon={faEye}
                        style={{ width: '20px', color: 'white' }}
                      />
                    </Link>
                  </div>
                </>
              )}
            </div>
          </Col>

          <div
            className="status-icon"
            style={{ backgroundColor: status() }}></div>
        </div>
      </Row>
    </div>
  )
}

export default SalesOrderApprove
